export default class User {
    constructor(data) {
        const {
            id,
            first_name,
            middle_name,
            no_middle_name,
            last_name,
            account_type,
            email,
            phone,
            phone_ext,
            drivers_license_state,
            drivers_license_number,
            execupay_employeeid,
            birthday_date,
            ssn_bg_check,
            emergency_name,
            emergency_email,
            emergency_phone,
            emergency_relationship,
            w4_fields,
            i9_fields,
            gender
        } = data;

        this.id = id;
        this.first_name = first_name;
        this.middle_name = middle_name;
        this.no_middle_name = no_middle_name;
        this.last_name = last_name;
        this.account_type = account_type;
        this.email = email;
        this.phone = phone;
        this.phone_ext = phone_ext;
        this.drivers_license_state = drivers_license_state;
        this.drivers_license_number = drivers_license_number;
        this.execupay_employeeid = execupay_employeeid;
        this.birthday_date = birthday_date;
        this.ssn_bg_check = ssn_bg_check && ssn_bg_check.indexOf('X') > 0 ? undefined : ssn_bg_check;
        this.emergency_name = emergency_name;
        this.emergency_email = emergency_email;
        this.emergency_phone = emergency_phone;
        this.emergency_relationship = emergency_relationship;
        this.w4_fields = w4_fields;
        this.i9_fields = i9_fields;
        this.gender = gender;
    }
}



// WEBPACK FOOTER //
// ./src/models/user.jsx